import React, { useRef } from "react";
import { Menu } from "primereact/menu";
import { useHierarchyService } from "../../hooks/useHierarchyService";
import _ from 'lodash'

const ProSetupActionMenu = ({performAction})=>{
    const menuRef = useRef(null);
    const {data:{selectedTreeNode}} = useHierarchyService();
   
    const getSetupMenuItems = ()=>{
        let items = [
            { label: 'Add', icon: 'fas fa-plus' ,command:()=>{ performAction("ADD") } },
            { label: 'Edit', icon: 'fas fa-edit', command:()=>{ performAction("EDIT")} },
            { label: 'Duplicate',  icon: 'pi pi-clone', command:()=>{ performAction("DUPLICATE")} },
            { label: 'Delete', icon: 'fas fa-trash-alt', command:()=>{ performAction("DELETE")} }
           
        ];
        if(selectedTreeNode.type === "BED"){
           items = _.drop(items);
        }
        return items ;
    }
    
    return <div>
    <i className="pi pi-ellipsis-h" onClick={(event) => menuRef && menuRef.current.toggle(event)} style={{ position: 'relative', top: 2 }}></i> 
    <Menu id={selectedTreeNode.key} model={getSetupMenuItems()} popup ref={menuRef} />
    
</div>
}

export default ProSetupActionMenu;